/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorNewRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.new',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorNewRoute);
